<ng-container *ngIf="productRequest">
    <capsule [label]="productRequest.status | prettifyProductRequestStatus | translate" [backgroundColor]="productRequest.status | getProductRequestStatusColor" [small]="true"></capsule>
</ng-container>
